export default {
  Save: 'Save',
  SaveAdd: 'SaveAdd',
  SaveClose: 'SaveClose',
  // Hoãn
  Postpone: 'Postpone',
  NextVoucher: 'NextVoucher',
  BackVoucher: 'BackVoucher',
  SaveView: 'SaveView',
  Ok: 'Ok',
  Delete: 'Delete',
  All: 'All',
  Follow: 'Follow',
  Unfollow: 'Unfollow',
  Active: 'Active',
  Unactive: 'Unactive',
  Edit: 'Edit',
  Duplicate: 'Duplicate',
  Add: 'Add',
  View: 'View',
  Posted: 'Posted',
  UnPosted: 'UnPosted',
  NextStep: 'NextStep',
  BackStep: 'BackStep',
  Refresh: 'Refresh',
  Copy: 'Copy',
  Import: 'Import',
  Close: 'Close',
}
